export default "__VITE_ASSET__D9fMlVcV__"